export const mediaTypes = {
    IMAGE: "donationImage",
    VIDEO: "donationVideo"
}
